export const LOAD_TOOL_MESSAGE = 'LOAD_TOOL_MESSAGE';
export const LOAD_TOOLS_MESSAGE = 'LOAD_TOOLS_MESSAGE';
export const UPDATE_TOOL_MESSAGE = 'UPDATE_TOOL_MESSAGE';

export const CREATE_DOC_MESSAGE = 'CEATE_DOC_MESSAGE';
export const UPDATE_DOC_MESSAGE = 'UPRDATE_DOC_MESSAGE';
export const DELETE_DOC_MESSAGE = 'DELETE_DOC_MESSAGE';

export const CREATE_ORGDOC_MESSAGE = 'CREATE_ORGDOC_MESSAGE';
export const UPDATE_ORGDOC_MESSAGE = 'UPDATE_ORGDOC_MESSAGE';
export const DELETE_ORGDOC_MESSAGE = 'DELETE_ORGDOC_MESSAGE';

export const SIGNUP_MESSAGE = 'SIGNUP_MESSAGE';
export const LOGIN_MESSAGE = 'LOGIN_MESSAGE';

export const URL_CHANGE_MESSAGE = 'URL_CHANGE_MESSAGE';
export const CHECK_TOOL_EXISTS_MESSAGE = 'CHECK_TOOL_EXISTS_MESSAGE';
export const CHECK_ORG_EXISTS_MESSAGE = 'CHECK_ORG_EXISTS_MESSAGE';

export const REPORT_EXTENSION_ERROR = 'REPORT_EXTENSION_ERROR';
